import{ FiThumbsUp } from'react-icons/fi' 

export const TeamMember = ({profile}) => {
    return (
        <li className="flex">
            <div className="flex-start">
                <img src={profile?.avatar||'/faces/1.png'} className="avatar" alt="" />
                <div className="flex-start action">
                    <div className="name">{profile?.name||'Tester'}</div>
                    <small className="profession">{profile?.profession||'Developer'}</small>
                </div>
            </div>
            <div className="description"> <FiThumbsUp /> </div>
        </li>
    )
} 